(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5850],{

/***/ 62810:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

exports.Z = _default;

/***/ }),

/***/ 38740:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

exports.Z = _default;

/***/ }),

/***/ 48485:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), 'SaveAlt');

exports.Z = _default;

/***/ }),

/***/ 92217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
}), 'ShareOutlined');

exports.Z = _default;

/***/ }),

/***/ 80617:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[slug]",
      function () {
        return __webpack_require__(27626);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ Button_Button; },
  "Z": function() { return /* reexport */ components_Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./components/Button/Button.module.scss
var Button_module = __webpack_require__(85474);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./components/Button/Button.tsx




var Button_Button = function(param) {
    var children = param.children, onClick = param.onClick, _href = param.href, href = _href === void 0 ? "" : _href, disabled = param.disabled, trackFunction = param.trackFunction, iconLeft = param.iconLeft, iconRight = param.iconRight, className = param.className;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((Button_module_default()).container, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            className: (Button_module_default()).myButton,
            variant: "contained",
            href: href,
            disabled: disabled,
            onClick: function() {
                if (disabled) {
                    return;
                }
                var ref;
                trackFunction === null || trackFunction === void 0 ? void 0 : trackFunction({
                    "element text": (ref = children === null || children === void 0 ? void 0 : children.toString()) !== null && ref !== void 0 ? ref : "",
                    "element type": "button"
                });
                onClick === null || onClick === void 0 ? void 0 : onClick();
            },
            startIcon: iconLeft,
            endIcon: iconRight,
            children: children
        })
    });
};
/* harmony default export */ var components_Button_Button = (Button_Button);

;// CONCATENATED MODULE: ./components/Button/index.ts



/***/ }),

/***/ 38628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ CMSChildrenContainer; },
  "Z": function() { return /* binding */ ChildrenContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./utils/stylesHelper.ts
// Future improvement could be to add baseClasses as a potential array - either array or string
// if (Array.isArray(baseClass)) { return [...baseClass, className].join(" ")
function combineClasses(baseClass, className) {
    return className ? "".concat(baseClass, " ").concat(className) : baseClass;
}

// EXTERNAL MODULE: ./components/CMS/ChildrenContainer/style.module.scss
var style_module = __webpack_require__(88460);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/CMS/ChildrenContainer/index.tsx




var CMSChildrenContainer = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: combineClasses((style_module_default()).childrenContainer, className),
        children: children
    });
};
/* harmony default export */ var ChildrenContainer = (CMSChildrenContainer);


/***/ }),

/***/ 79989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ MarkdownContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88415);
/* harmony import */ var _cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30724);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_CMS_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70738);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55530);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_5__);







var MarkdownContent = function(param) {
    var source = param.source;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_3___default()), {
        source: source,
        renderers: components_CMS_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().markdown), (_cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().markdownContent)),
        escapeHtml: false
    });
};


/***/ }),

/***/ 70738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29260);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91066);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable react/display-name */ 



var MarkdownRenderer = {
    link: function(props) {
        var href = props.href, children = props.children;
        var shouldUseTargetSelf = /^(https?):\/\//.test(href) ?  true ? href.startsWith(window.location.origin) // In case someone pastes the full URL
         : 0 : /*
         * Anything else should use target="_self". Especially anything that starts with mailto, tel, or javascript
         */ true;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: shouldUseTargetSelf ? "_self" : "_blank",
            rel: "noreferrer noopener",
            children: children
        });
    },
    image: function(props) {
        var src = props.src, title = props.title;
        if (src.match(/\.(jpeg|jpg|gif|png)$/)) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: src,
                        style: {
                            display: "block",
                            width: "80%",
                            height: "400px",
                            objectFit: "cover",
                            margin: "0 auto"
                        },
                        alt: "cover image"
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imageAndLinkTitle),
                        children: title
                    })
                ]
            });
        }
        if (src.match(/\.(mp4|ogg|webm)$/)) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                        controls: true,
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().videoPlayer),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                            src: src
                        })
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imageAndLinkTitle),
                        children: title
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownRenderer);


/***/ }),

/***/ 34935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ FieldError; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_icons_ErrorOutline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38740);
/* harmony import */ var _FieldError_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36135);
/* harmony import */ var _FieldError_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_FieldError_module_scss__WEBPACK_IMPORTED_MODULE_1__);



var FieldError = function(param) {
    var errorMessage = param.errorMessage;
    if (!errorMessage) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_FieldError_module_scss__WEBPACK_IMPORTED_MODULE_1___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_FieldError_module_scss__WEBPACK_IMPORTED_MODULE_1___default().iconContainer),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ErrorOutline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_FieldError_module_scss__WEBPACK_IMPORTED_MODULE_1___default().error),
                children: errorMessage
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (FieldError)));


/***/ }),

/***/ 35079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ShareContainer_ShareContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/urlHelper.ts
var urlHelper = __webpack_require__(52484);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./utils/useCloseOnOutsideClick.ts
var useCloseOnOutsideClick = __webpack_require__(42361);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Popper/Popper.js + 1 modules
var Popper = __webpack_require__(84872);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ShareOutlined.js
var ShareOutlined = __webpack_require__(92217);
// EXTERNAL MODULE: ./components/ShareContainer/ShareContainer.module.scss
var ShareContainer_module = __webpack_require__(4423);
var ShareContainer_module_default = /*#__PURE__*/__webpack_require__.n(ShareContainer_module);
;// CONCATENATED MODULE: ./components/ShareContainer/ShareContainer.tsx













var ShareEmail = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9272).then(__webpack_require__.bind(__webpack_require__, 19272));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19272)
            ];
        }
    }
});
var ShareFacebook = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7753).then(__webpack_require__.bind(__webpack_require__, 37753));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37753)
            ];
        }
    }
});
var ShareLink = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9261).then(__webpack_require__.bind(__webpack_require__, 29261));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29261)
            ];
        }
    }
});
var ShareContainer = function(param) {
    var className = param.className, emailTitle = param.emailTitle, emailSubject = param.emailSubject, emailBody = param.emailBody, facebookTitle = param.facebookTitle, shareUrl = param.shareUrl, shareTrackingProps = param.shareTrackingProps, id = param.id, _popperPlacement = param.popperPlacement, popperPlacement = _popperPlacement === void 0 ? "bottom" : _popperPlacement, jobOrArticleShare = param.jobOrArticleShare;
    var ref;
    var url = shareUrl !== null && shareUrl !== void 0 ? shareUrl : (ref = globalThis.location) === null || ref === void 0 ? void 0 : ref.href;
    var ref1 = (0,react.useState)(false), isShareOpen = ref1[0], setIsShareOpen = ref1[1];
    var ref2 = (0,react.useState)(false), isDialogOpen = ref2[0], setIsDialogOpen = ref2[1];
    var shareButtonRef = (0,react.useRef)(null);
    var containerRef = (0,useCloseOnOutsideClick/* useCloseOnOutsideClick */.N)(isShareOpen && !isDialogOpen, setIsShareOpen);
    var popperId = "share-dropdown_".concat(id);
    var track = (0,useAnalytics/* useAnalytics */.z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "outlined",
                color: "secondary",
                "data-testid": "share-dropdown-button",
                ref: shareButtonRef,
                onClick: function() {
                    setIsShareOpen(!isShareOpen);
                    track("Click Share button", shareTrackingProps.details);
                },
                "aria-controls": popperId,
                "aria-haspopup": "true",
                "aria-expanded": isShareOpen,
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareOutlined/* default */.Z, {}),
                fullWidth: true,
                children: "Share"
            }),
            isShareOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                id: popperId,
                "data-testid": "share-dropdown",
                open: isShareOpen,
                anchorEl: shareButtonRef.current,
                placement: popperPlacement,
                transition: true,
                disablePortal: true,
                className: (ShareContainer_module_default()).popper,
                children: function(param) {
                    var TransitionProps = param.TransitionProps;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, TransitionProps), {
                        timeout: 350,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ShareContainer_module_default()).dropdownContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ShareContainer_module_default()).item,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareLink, {
                                        shareUrl: (0,urlHelper/* getUtmShareUrl */.En)(jobOrArticleShare, url, "copy"),
                                        onClick: function() {
                                            setIsShareOpen(false);
                                            track(shareTrackingProps.name, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shareTrackingProps.details), {
                                                "Share Type": "Link"
                                            }));
                                        },
                                        className: (ShareContainer_module_default()).button
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ShareContainer_module_default()).item,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareEmail, {
                                        title: emailTitle,
                                        subject: emailSubject,
                                        body: emailBody,
                                        onClick: function() {
                                            setIsShareOpen(false);
                                            track(shareTrackingProps.name, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shareTrackingProps.details), {
                                                "Share Type": "Email"
                                            }));
                                        },
                                        className: (ShareContainer_module_default()).button,
                                        onDialogStatusChange: function(isDialogOpen) {
                                            return setIsDialogOpen(isDialogOpen);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ShareContainer_module_default()).item,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareFacebook, {
                                        title: facebookTitle,
                                        shareUrl: (0,urlHelper/* getUtmShareUrl */.En)(jobOrArticleShare, url, "social"),
                                        onClick: function() {
                                            setIsShareOpen(false);
                                            track(shareTrackingProps.name, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shareTrackingProps.details), {
                                                "Share Type": "Facebook"
                                            }));
                                        },
                                        className: (ShareContainer_module_default()).button
                                    })
                                })
                            ]
                        })
                    }));
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        ]
    });
};
/* harmony default export */ var ShareContainer_ShareContainer = (ShareContainer);

;// CONCATENATED MODULE: ./components/ShareContainer/index.tsx



/***/ }),

/***/ 90943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ TextFieldWithRef; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_FieldError_FieldError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34935);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _TextField_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61195);
/* harmony import */ var _TextField_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_TextField_module_scss__WEBPACK_IMPORTED_MODULE_5__);









var TextField = function(_param, ref) {
    var type = _param.type, label = _param.label, value = _param.value, name = _param.name, error = _param.error, errorMessage = _param.errorMessage, defaultValue = _param.defaultValue, disabled = _param.disabled, required = _param.required, onChange = _param.onChange, onFocus = _param.onFocus, onBlur = _param.onBlur, className = _param.className, containerClassName = _param.containerClassName, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "type",
        "label",
        "value",
        "name",
        "error",
        "errorMessage",
        "defaultValue",
        "disabled",
        "required",
        "onChange",
        "onFocus",
        "onBlur",
        "className",
        "containerClassName"
    ]);
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isFocused = _$ref[0], setIsFocused = _$ref[1];
    var isFilled = value !== undefined && value !== null && value !== "";
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_TextField_module_scss__WEBPACK_IMPORTED_MODULE_5___default().container), containerClassName),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                ref: ref,
                type: type,
                id: label,
                value: value !== null && value !== void 0 ? value : "",
                defaultValue: defaultValue,
                name: name,
                onChange: onChange,
                onFocus: function(e) {
                    setIsFocused(true);
                    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
                },
                onBlur: function(e) {
                    setIsFocused(false);
                    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
                },
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, error && (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_5___default().error)),
                disabled: disabled,
                required: required
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: label,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_5___default().focusedLabel), isFocused), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_5___default().filledLabel), isFilled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_5___default().requiredLabel), required), _obj)),
                children: label
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FieldError_FieldError__WEBPACK_IMPORTED_MODULE_1__/* .FieldError */ .c, {
                errorMessage: errorMessage
            })
        ]
    });
};
var TextFieldWithRef = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(TextField);

/* harmony default export */ __webpack_exports__["Z"] = (TextFieldWithRef);


/***/ }),

/***/ 53189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* reexport */ TickList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CheckBox.js
var CheckBox = __webpack_require__(62810);
// EXTERNAL MODULE: ./components/TickList/TickList.module.scss
var TickList_module = __webpack_require__(6705);
var TickList_module_default = /*#__PURE__*/__webpack_require__.n(TickList_module);
;// CONCATENATED MODULE: ./components/TickList/TickList.tsx




var TickList = function(param) {
    var items = param.items, variant = param.variant;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((TickList_module_default()).container, variant === "small" && (TickList_module_default()).container_small),
        children: items.map(function(item, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TickList_module_default()).listItem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* default */.Z, {
                        className: (TickList_module_default()).checkIcon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: item
                    })
                ]
            }, i);
        })
    });
};

;// CONCATENATED MODULE: ./components/TickList/index.ts



/***/ }),

/***/ 27626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Article": function() { return /* binding */ Article; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./modules/Context/useAuth0User.tsx
var useAuth0User = __webpack_require__(65200);
// EXTERNAL MODULE: ./utils/appClientConfig.ts
var appClientConfig = __webpack_require__(77469);
// EXTERNAL MODULE: ./utils/urlHelper.ts
var urlHelper = __webpack_require__(52484);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/CMS/ArticleTags/style.module.scss
var style_module = __webpack_require__(51196);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/CMS/ArticleTags/index.tsx





var ArticleTags = function(param) {
    var tags = param.tags;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (style_module_default()).container,
        children: tags.map(function(tag) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: "".concat(path/* PATH.ARTICLE_TAG */.m.ARTICLE_TAG, "/").concat(tag.slug),
                as: "".concat(path/* PATH.ARTICLE_TAG */.m.ARTICLE_TAG, "/").concat(tag.slug),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "".concat(path/* PATH.ARTICLE_TAG */.m.ARTICLE_TAG, "/").concat(tag.slug),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (style_module_default()).tag,
                        children: [
                            "#",
                            tag.name
                        ]
                    })
                })
            }, tag.id);
        })
    });
};

// EXTERNAL MODULE: ./utils/dateHelper.ts
var dateHelper = __webpack_require__(78219);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/Person.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var Person = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person'));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Avatar/Avatar.js








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: 40,
      height: 40,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(20),
      lineHeight: 1,
      borderRadius: '50%',
      overflow: 'hidden',
      userSelect: 'none'
    },

    /* Styles applied to the root element if not `src` or `srcSet`. */
    colorDefault: {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },

    /* Styles applied to the root element if `variant="circle"`. */
    circle: {},

    /* Styles applied to the root element if `variant="circular"`. */
    circular: {},

    /* Styles applied to the root element if `variant="rounded"`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="square"`. */
    square: {
      borderRadius: 0
    },

    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
    img: {
      width: '100%',
      height: '100%',
      textAlign: 'center',
      // Handle non-square image. The property isn't supported by IE 11.
      objectFit: 'cover',
      // Hide alt text.
      color: 'transparent',
      // Hide the image broken icon, only works on Chrome.
      textIndent: 10000
    },

    /* Styles applied to the fallback icon */
    fallback: {
      width: '75%',
      height: '75%'
    }
  };
};

function useLoaded(_ref) {
  var src = _ref.src,
      srcSet = _ref.srcSet;

  var _React$useState = react.useState(false),
      loaded = _React$useState[0],
      setLoaded = _React$useState[1];

  react.useEffect(function () {
    if (!src && !srcSet) {
      return undefined;
    }

    setLoaded(false);
    var active = true;
    var image = new Image();
    image.src = src;
    image.srcSet = srcSet;

    image.onload = function () {
      if (!active) {
        return;
      }

      setLoaded('loaded');
    };

    image.onerror = function () {
      if (!active) {
        return;
      }

      setLoaded('error');
    };

    return function () {
      active = false;
    };
  }, [src, srcSet]);
  return loaded;
}

var Avatar = /*#__PURE__*/react.forwardRef(function Avatar(props, ref) {
  var alt = props.alt,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      imgProps = props.imgProps,
      sizes = props.sizes,
      src = props.src,
      srcSet = props.srcSet,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'circular' : _props$variant,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["alt", "children", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"]);

  var children = null; // Use a hook instead of onError on the img element to support server-side rendering.

  var loaded = useLoaded({
    src: src,
    srcSet: srcSet
  });
  var hasImg = src || srcSet;
  var hasImgNotFailing = hasImg && loaded !== 'error';

  if (hasImgNotFailing) {
    children = /*#__PURE__*/react.createElement("img", (0,esm_extends/* default */.Z)({
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      className: classes.img
    }, imgProps));
  } else if (childrenProp != null) {
    children = childrenProp;
  } else if (hasImg && alt) {
    children = alt[0];
  } else {
    children = /*#__PURE__*/react.createElement(Person, {
      className: classes.fallback
    });
  }

  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, classes.system, classes[variant], className, !hasImgNotFailing && classes.colorDefault),
    ref: ref
  }, other), children);
});
 false ? 0 : void 0;
/* harmony default export */ var Avatar_Avatar = ((0,withStyles/* default */.Z)(styles, {
  name: 'MuiAvatar'
})(Avatar));
;// CONCATENATED MODULE: ./components/CMS/Author/AuthorAvatar/index.tsx




var AuthorAvatar = function(param) {
    var className = param.className, avatar = param.avatar, altText = param.altText;
    var imageUrl = avatar.formats ? avatar.formats.thumbnail.url : avatar.url;
    return imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar_Avatar, {
        className: className,
        "data-testid": avatar.formats ? "formatted" : "noFormat",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            alt: altText,
            src: imageUrl,
            layout: "fixed",
            objectFit: "cover",
            quality: 30,
            height: 86,
            width: 86
        })
    }) : null;
};

// EXTERNAL MODULE: ./components/CMS/Author/style.module.scss
var Author_style_module = __webpack_require__(90561);
var Author_style_module_default = /*#__PURE__*/__webpack_require__.n(Author_style_module);
;// CONCATENATED MODULE: ./components/CMS/Author/index.tsx





var Author = function(param) {
    var author = param.author, date = param.date;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Author_style_module_default()).container,
        children: [
            author.avatar && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorAvatar, {
                className: (Author_style_module_default()).avatar,
                altText: author.name,
                avatar: author.avatar
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Author_style_module_default()).introduction,
                children: [
                    date && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Author_style_module_default()).date,
                        children: (0,dateHelper/* parseAndFormatDate */.PN)(date, "DD MMMM YYYY")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (Author_style_module_default()).name,
                        children: [
                            "Article by ",
                            author.name
                        ]
                    }),
                    author.occupation && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: author.occupation
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/CMS/ChildrenContainer/index.tsx + 1 modules
var ChildrenContainer = __webpack_require__(38628);
// EXTERNAL MODULE: ./components/CMS/CmsImage/index.ts + 2 modules
var CmsImage = __webpack_require__(78868);
// EXTERNAL MODULE: ./components/CMS/ArticlePublisher/index.tsx
var ArticlePublisher = __webpack_require__(62173);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./components/Image/index.tsx + 2 modules
var components_Image = __webpack_require__(87113);
// EXTERNAL MODULE: ./components/CMS/ArticleItemTopWithBg/style.module.scss
var ArticleItemTopWithBg_style_module = __webpack_require__(10788);
var ArticleItemTopWithBg_style_module_default = /*#__PURE__*/__webpack_require__.n(ArticleItemTopWithBg_style_module);
;// CONCATENATED MODULE: ./components/CMS/ArticleItemTopWithBg/index.tsx









var ArticleItemTopWithBg = function(param) {
    var article = param.article, onClick = param.onClick;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ArticleItemTopWithBg_style_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            prefetch: false,
            href: "".concat(path/* PATH.ARTICLES */.m.ARTICLES, "/").concat(article.slug),
            as: "".concat(path/* PATH.ARTICLES */.m.ARTICLES, "/").concat(article.slug),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: (ArticleItemTopWithBg_style_module_default()).link,
                role: "link",
                tabIndex: 0,
                onClick: onClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ArticleItemTopWithBg_style_module_default()).cover,
                        children: [
                            article.cover && /*#__PURE__*/ (0,jsx_runtime.jsx)(CmsImage/* default */.Z, {
                                altText: article.cover.alternativeText || components_Image/* defaultAlt */.Zp,
                                imageProps: article.cover,
                                className: (ArticleItemTopWithBg_style_module_default()).image,
                                format: "small",
                                layout: "fill",
                                width: 292,
                                height: 164
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ArticleItemTopWithBg_style_module_default()).topLeft,
                                children: (ref = article.article_category) === null || ref === void 0 ? void 0 : ref.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ArticleItemTopWithBg_style_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ArticleItemTopWithBg_style_module_default()).title,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h6",
                                    component: "h2",
                                    children: article.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ArticleItemTopWithBg_style_module_default()).blurb,
                                children: article.blurb
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePublisher/* ArticlePublisher */.n, {
                                author: article.author,
                                publishedDate: article.published_date
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
;// CONCATENATED MODULE: ./components/CMS/RelatedArticles/index.tsx





var RelatedArticles = function(param) {
    var article = param.article, articles = param.articles;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
        container: true,
        spacing: 3,
        children: articles.map(function(relatedArticle) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: 12,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleItemTopWithBg, {
                    article: relatedArticle,
                    onClick: function() {
                        track("Click Related Article", {
                            title: relatedArticle.title,
                            id: relatedArticle.id,
                            source_title: article.title,
                            source_id: article.id
                        });
                    }
                }, relatedArticle.slug)
            }, relatedArticle.id);
        })
    });
};

// EXTERNAL MODULE: ./components/BackgroundBannerImage/BackgroundBannerImage.tsx
var BackgroundBannerImage = __webpack_require__(64673);
// EXTERNAL MODULE: ./components/ShareContainer/index.tsx + 1 modules
var ShareContainer = __webpack_require__(35079);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./components/TickList/index.ts + 1 modules
var TickList = __webpack_require__(53189);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./modules/SalaryGuide/SalaryGuide.module.scss
var SalaryGuide_module = __webpack_require__(6244);
var SalaryGuide_module_default = /*#__PURE__*/__webpack_require__.n(SalaryGuide_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./components/Button/index.ts + 1 modules
var Button = __webpack_require__(56419);
// EXTERNAL MODULE: ./components/FieldError/FieldError.tsx
var FieldError = __webpack_require__(34935);
;// CONCATENATED MODULE: ./components/FieldError/index.ts


// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./components/TermsAndConditions/TermsAndConditions.module.scss
var TermsAndConditions_module = __webpack_require__(68818);
var TermsAndConditions_module_default = /*#__PURE__*/__webpack_require__.n(TermsAndConditions_module);
;// CONCATENATED MODULE: ./components/TermsAndConditions/TermsAndConditions.tsx








var termsAndConditionsPath = path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS;
var privacyPolicyUrl = appClientConfig/* appClientConfig.privacyPolicyUrl */.p.privacyPolicyUrl;
var TermsAndConditions = function(param) {
    var control = param.control, error = param.error, errorMessage = param.errorMessage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (TermsAndConditions_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                name: "agreeTerms",
                control: control,
                defaultValue: false,
                render: function(param) {
                    var onChange = param.onChange, value = param.value;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: value,
                        onChange: function() {
                            return onChange(!value);
                        },
                        style: {
                            color: value ? "#0f68ef" : "#889096",
                            padding: 6,
                            paddingLeft: 0
                        }
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (TermsAndConditions_module_default()).terms,
                children: [
                    "I agree to the",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        prefetch: false,
                        href: termsAndConditionsPath,
                        as: termsAndConditionsPath,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: (TermsAndConditions_module_default()).link,
                            href: termsAndConditionsPath,
                            children: "terms and conditions"
                        })
                    }),
                    " ",
                    "and",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        prefetch: false,
                        href: privacyPolicyUrl,
                        as: privacyPolicyUrl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: (TermsAndConditions_module_default()).link,
                            href: privacyPolicyUrl,
                            children: "privacy policy"
                        })
                    }),
                    "."
                ]
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldError/* FieldError */.c, {
                errorMessage: errorMessage
            })
        ]
    });
};
/* harmony default export */ var TermsAndConditions_TermsAndConditions = (TermsAndConditions);

;// CONCATENATED MODULE: ./components/TermsAndConditions/index.ts


// EXTERNAL MODULE: ./components/TextField/TextField.tsx
var TextField = __webpack_require__(90943);
;// CONCATENATED MODULE: ./components/TextField/index.ts


// EXTERNAL MODULE: ./utils/capitaliseFirstChar.ts
var capitaliseFirstChar = __webpack_require__(81754);
// EXTERNAL MODULE: ./utils/customisedYup.ts
var customisedYup = __webpack_require__(79427);
// EXTERNAL MODULE: ./utils/useRequest.ts
var useRequest = __webpack_require__(87243);
// EXTERNAL MODULE: ./modules/RegistrationFlow/steps-old/RegisterBasicInfo/RegisterBasicInfo.tsx + 4 modules
var RegisterBasicInfo = __webpack_require__(35545);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/dist/index.esm.js
var dist_index_esm = __webpack_require__(96235);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/SaveAlt.js
var SaveAlt = __webpack_require__(48485);
;// CONCATENATED MODULE: ./modules/SalaryGuide/components/SalaryGuideForm.tsx

















var registerSchema = customisedYup/* default.object */.Z.object().shape({
    email: customisedYup/* default.string */.Z.string().trim().max(80, RegisterBasicInfo/* emailLengthHint */.oe).required().emailValidation(),
    firstName: customisedYup/* default.string */.Z.string().trim().max(40, RegisterBasicInfo/* firstNameLengthHint */.qP).required(),
    lastName: customisedYup/* default.string */.Z.string().trim().max(80, RegisterBasicInfo/* lastNameLengthHint */.O8).required(),
    agreeTerms: customisedYup/* default.boolean */.Z.boolean().required("You must agree to the terms and conditions")
});
var SalaryGuideForm = function() {
    var ref;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var ref1 = (0,index_esm/* useForm */.cI)({
        resolver: (0,dist_index_esm/* yupResolver */.Xp)(registerSchema),
        reValidateMode: "onBlur",
        mode: "onBlur",
        defaultValues: {
            firstName: "",
            lastName: "",
            email: "",
            agreeTerms: false
        }
    }), handleSubmit = ref1.handleSubmit, errors = ref1.errors, getValues = ref1.getValues, control = ref1.control, formState = ref1.formState, watch = ref1.watch;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var firstName, lastName, email, payload, formBody, url, newTab;
            return (0,tslib_es6.__generator)(this, function(_state) {
                firstName = data.firstName, lastName = data.lastName, email = data.email;
                payload = {
                    // API expects pascal case keys
                    FirstName: firstName,
                    LastName: lastName,
                    Email: email,
                    LeadSource: "jmr_au"
                };
                formBody = new URLSearchParams(payload).toString();
                (0,useRequest/* postLeadforms */.Dl)(formBody); // note - errors are logged and caught in postLeadforms - makeRequestAndNoticeErrors
                url = "https://med-cms-bucket-production.s3.ap-southeast-2.amazonaws.com/AU_GEN_FY_25_Salary_Guide_dcd83caeeb.pdf";
                newTab = window.open(url, "_blank", "noopener");
                newTab === null || newTab === void 0 ? void 0 : newTab.focus();
                return [
                    2
                ];
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var submitEnabled = !formState.isSubmitting && formState.isValid && watch("agreeTerms");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: (SalaryGuide_module_default()).formContainer,
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                name: "firstName",
                control: control,
                defaultValue: "",
                render: function(param) {
                    var onChange = param.onChange, onBlur = param.onBlur, value = param.value, name = param.name;
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        name: name,
                        value: value,
                        onChange: function(e) {
                            var val = (0,capitaliseFirstChar/* capitaliseFirstChar */.f)(e.target.value);
                            onChange(val);
                        },
                        onBlur: onBlur,
                        label: "First name",
                        required: true,
                        error: !!errors.firstName,
                        errorMessage: (ref = errors.firstName) === null || ref === void 0 ? void 0 : ref.message,
                        type: "text"
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                name: "lastName",
                control: control,
                defaultValue: "",
                render: function(param) {
                    var onChange = param.onChange, onBlur = param.onBlur, value = param.value, name = param.name;
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        name: name,
                        value: value,
                        onChange: function(e) {
                            var val = (0,capitaliseFirstChar/* capitaliseFirstChar */.f)(e.target.value);
                            onChange(val);
                        },
                        onBlur: onBlur,
                        label: "Last name",
                        required: true,
                        error: !!errors.lastName,
                        errorMessage: (ref = errors.lastName) === null || ref === void 0 ? void 0 : ref.message,
                        type: "text"
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                name: "email",
                control: control,
                defaultValue: "",
                render: function(param) {
                    var onChange = param.onChange, onBlur = param.onBlur, value = param.value, name = param.name;
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        name: name,
                        value: value,
                        onChange: onChange,
                        onBlur: onBlur,
                        label: "Email address",
                        required: true,
                        error: !!errors.email,
                        errorMessage: (ref = errors.email) === null || ref === void 0 ? void 0 : ref.message,
                        type: "text"
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions_TermsAndConditions, {
                control: control,
                error: !!errors.agreeTerms,
                errorMessage: (ref = errors.agreeTerms) === null || ref === void 0 ? void 0 : ref.message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                type: "submit",
                disabled: !submitEnabled,
                trackFunction: function(eventProps) {
                    track("Click", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eventProps), {
                        action: "Download"
                    }));
                },
                iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveAlt/* default */.Z, {
                    fontSize: "small"
                }),
                onClick: function() {
                    return onSubmit(getValues());
                },
                children: "Download"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/SalaryGuide/SalaryGuide.tsx







function SalaryGuide(param) {
    var _fullPage = param.fullPage, fullPage = _fullPage === void 0 ? false : _fullPage;
    var isDesktop = (0,useMediaQuery/* default */.Z)("(min-width: 1140px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SalaryGuide_module_default()).salaryGuide,
        children: [
            isDesktop && fullPage === true && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/assets/guide-book.svg",
                priority: false,
                alt: "",
                "aria-hidden": true,
                width: 149,
                height: 198
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: (SalaryGuide_module_default()).salaryGuideTitle,
                        children: [
                            "FY25 Australian ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Salary Guide"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (SalaryGuide_module_default()).subHeading,
                        children: "Download our free FY25 guide and get the inside scoop on:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TickList/* TickList */.l, {
                        variant: "small",
                        items: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (SalaryGuide_module_default()).listItem,
                                children: [
                                    "What doctors ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "are earning"
                                    })
                                ]
                            }, "earning"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (SalaryGuide_module_default()).listItem,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Industry trends"
                                })
                            }, "trends"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (SalaryGuide_module_default()).listItem,
                                children: [
                                    "How to ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "get ahead in 2025"
                                    })
                                ]
                            }, "get-ahead"), 
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        prefetch: false,
                        href: "/doctors/resources",
                        as: "/doctors/resources",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: (SalaryGuide_module_default()).downloadText,
                            children: "Preview all available resources"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryGuideForm, {})
        ]
    });
}

;// CONCATENATED MODULE: ./modules/SalaryGuide/index.ts


// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button_Button = __webpack_require__(282);
// EXTERNAL MODULE: ./components/CMS/ArticleCallToAction/ArticleCallToAction.module.scss
var ArticleCallToAction_module = __webpack_require__(14300);
var ArticleCallToAction_module_default = /*#__PURE__*/__webpack_require__.n(ArticleCallToAction_module);
;// CONCATENATED MODULE: ./components/CMS/ArticleCallToAction/ArticleCallToAction.tsx









var ArticleCallToAction = function(param) {
    var copy = param.copy, cta = param.cta, className = param.className, name = param.name, link = param.link, ctaPosition = param.ctaPosition;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    if (name.includes("JMR AU")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryGuide, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ArticleCallToAction_module_default()).container, className),
        "data-testid": "article-call-to-action",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                component: "h6",
                className: (ArticleCallToAction_module_default()).text,
                children: copy
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: link,
                as: link,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "contained",
                    color: "secondary",
                    href: link,
                    className: (ArticleCallToAction_module_default()).ctaButton,
                    onClick: function() {
                        track("Article CTA click", {
                            name: name,
                            ctaPosition: ctaPosition
                        });
                    },
                    children: cta
                })
            })
        ]
    });
};
/* harmony default export */ var ArticleCallToAction_ArticleCallToAction = (ArticleCallToAction);

;// CONCATENATED MODULE: ./components/CMS/ArticleCallToAction/index.tsx


// EXTERNAL MODULE: ./components/CMS/MarkdownContent/index.tsx
var MarkdownContent = __webpack_require__(79989);
// EXTERNAL MODULE: ./modules/ArticleContentWithCta/ArticleContentWithCta.module.scss
var ArticleContentWithCta_module = __webpack_require__(2043);
var ArticleContentWithCta_module_default = /*#__PURE__*/__webpack_require__.n(ArticleContentWithCta_module);
;// CONCATENATED MODULE: ./modules/ArticleContentWithCta/ArticleContentWithCta.tsx








var ARTICLE_CTA_INSERT = "{{INSERT_CTA_HERE}}";
var ARTICLE_CTA_INSERT_REGEX = new RegExp(/^\s*\{\{INSERT_CTA_HERE}}\s*$/gm);
function articleContentHasCtaInsert(content) {
    return ARTICLE_CTA_INSERT_REGEX.test(content);
}
var generateOldCta = function(cta, ctaPosition) {
    var ctaClass = "";
    if (ctaPosition === "BOTTOM") {
        ctaClass = classnames_default()((ArticleContentWithCta_module_default()).ctaBannerBottom);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCallToAction_ArticleCallToAction, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cta), {
        ctaPosition: ctaPosition,
        className: ctaClass
    }));
};
function addCtaToBlocks(blocks, props, ctaPosition, hasCtaInsert) {
    if ("articleCta" in props && props.articleCta) {
        // If there was no INSERT_CTA_HERE token but the CTA is supposed to be put in the middle,
        // we should force the CTA to be put at the end instead
        var endPositionOverride = props.ctaPosition === "MIDDLE" && ctaPosition === "BOTTOM" && !hasCtaInsert;
        if (props.ctaPosition === ctaPosition || endPositionOverride) {
            blocks.push(generateOldCta(props.articleCta, props.ctaPosition));
        }
    }
}
var ArticleContentWithCta = function(props) {
    var content = props.content;
    var splitItems = content.split(ARTICLE_CTA_INSERT_REGEX);
    var hasCtaInsert = splitItems.length > 1;
    var blocks = [];
    addCtaToBlocks(blocks, props, "TOP", hasCtaInsert);
    for(var i = 0; i < splitItems.length; i++){
        blocks.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownContent/* MarkdownContent */.S, {
            source: splitItems[i]
        }));
        // Don't add a CTA after the last block
        if (i + 1 < splitItems.length) {
            addCtaToBlocks(blocks, props, "MIDDLE", hasCtaInsert);
        }
    }
    addCtaToBlocks(blocks, props, "BOTTOM", hasCtaInsert);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: blocks
    });
};
/* harmony default export */ var ArticleContentWithCta_ArticleContentWithCta = (ArticleContentWithCta);

// EXTERNAL MODULE: ./modules/ContentHubContainer/index.tsx + 1 modules
var ContentHubContainer = __webpack_require__(26877);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./pages/articles/style.module.scss
var articles_style_module = __webpack_require__(17798);
var articles_style_module_default = /*#__PURE__*/__webpack_require__.n(articles_style_module);
;// CONCATENATED MODULE: ./pages/articles/[slug].tsx






















var __N_SSP = true;
function Article(param) {
    var user = param.user, article = param.article, relatedArticles = param.relatedArticles, articleCtaPosition = param.articleCtaPosition;
    var ref;
    var articleCategory = article.article_category, author = article.author, cover = article.cover, articleCta = article.article_cta, title = article.title, content = article.content, published_date = article.published_date, tags = article.tags;
    var newLineEncoding = "%0d%0a";
    var _alternativeText, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: (articles_style_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (articles_style_module_default()).path,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        prefetch: false,
                        href: path/* PATH.ARTICLES */.m.ARTICLES,
                        as: path/* PATH.ARTICLES */.m.ARTICLES,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: path/* PATH.ARTICLES */.m.ARTICLES,
                            children: "Articles"
                        })
                    }),
                    " ",
                    "/",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        prefetch: false,
                        href: "".concat(path/* PATH.ARTICLE_CATEGORY */.m.ARTICLE_CATEGORY, "/").concat(articleCategory === null || articleCategory === void 0 ? void 0 : articleCategory.slug),
                        as: "".concat(path/* PATH.ARTICLE_CATEGORY */.m.ARTICLE_CATEGORY, "/").concat(articleCategory === null || articleCategory === void 0 ? void 0 : articleCategory.slug),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "".concat(path/* PATH.ARTICLE_CATEGORY */.m.ARTICLE_CATEGORY, "/").concat(articleCategory === null || articleCategory === void 0 ? void 0 : articleCategory.slug),
                            children: articleCategory === null || articleCategory === void 0 ? void 0 : articleCategory.name
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (articles_style_module_default()).title,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h4",
                            component: "h1",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            cover && /*#__PURE__*/ (0,jsx_runtime.jsx)(CmsImage/* default */.Z, {
                                imageProps: cover,
                                altText: (_alternativeText = cover.alternativeText) !== null && _alternativeText !== void 0 ? _alternativeText : components_Image/* defaultAlt */.Zp,
                                format: "large",
                                priority: true,
                                layout: "responsive",
                                height: cover.height,
                                width: cover.width,
                                objectFit: "cover",
                                sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 80vw, (max-width: 1920px) 70vw, (max-width: 2560px) 70vw, 1920px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: (ref1 = cover === null || cover === void 0 ? void 0 : cover.caption) !== null && ref1 !== void 0 ? ref1 : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleContentWithCta_ArticleContentWithCta, {
                            content: content,
                            articleCta: articleCta,
                            ctaPosition: articleCtaPosition
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (articles_style_module_default()).authorAndShare,
                        children: [
                            author && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (articles_style_module_default()).author,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Author, {
                                    author: author,
                                    date: published_date
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareContainer/* default */.Z, {
                                id: article.id,
                                className: (articles_style_module_default()).share,
                                jobOrArticleShare: "articleshare",
                                emailTitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "Who would you like to ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " send this article to?"
                                    ]
                                }),
                                emailSubject: "".concat((ref2 = user === null || user === void 0 ? void 0 : user.given_name) !== null && ref2 !== void 0 ? ref2 : "Medrecruit", " shared an article with you"),
                                emailBody: "Read the article from ".concat((ref3 = user === null || user === void 0 ? void 0 : user.given_name) !== null && ref3 !== void 0 ? ref3 : "Medrecruit", " ").concat(newLineEncoding).concat(encodeURI((0,urlHelper/* getUtmShareUrl */.En)("articleshare", (ref = globalThis.location) === null || ref === void 0 ? void 0 : ref.href, "email"))),
                                facebookTitle: title,
                                shareTrackingProps: {
                                    name: "Share Article",
                                    details: {
                                        "Share Origin": "Articles",
                                        "Article Id": article.id,
                                        "Article Title": title
                                    }
                                },
                                popperPlacement: "bottom-end"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (articles_style_module_default()).tag,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleTags, {
                    tags: tags
                })
            }),
            relatedArticles.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (articles_style_module_default()).relatedArticleTitle,
                        children: "Related Articles"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: (articles_style_module_default()).line
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (articles_style_module_default()).relatedArticles,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundBannerImage/* BackgroundBannerImage */.M, {
                                priority: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenContainer/* CMSChildrenContainer */.z, {
                                className: (articles_style_module_default()).articles,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedArticles, {
                                    article: article,
                                    articles: relatedArticles
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var Post = function(param) {
    var article = param.article, relatedArticles = param.relatedArticles, categories = param.categories, articleCtaPosition = param.articleCtaPosition;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var router = (0,next_router.useRouter)();
    var user = (0,useAuth0User/* useAuth0User */.a)().user;
    (0,react.useEffect)(function() {
        track("Article page loaded", {
            title: article.title,
            id: article.id,
            ctaPosition: articleCtaPosition
        });
    }, [
        router.query
    ]);
    var ref7, ref8, ref9, ref10, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentHubContainer/* ContentHubContainer */._, {
        categories: categories,
        selectedCategorySlug: (ref = article.article_category) === null || ref === void 0 ? void 0 : ref.slug,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: article.meta_title,
                description: article.meta_description,
                noindex: !article.index,
                nofollow: !article.index,
                openGraph: {
                    title: article.title,
                    description: article.blurb,
                    type: "article",
                    article: {
                        publishedTime: article.published_date,
                        authors: [
                            (ref7 = (ref1 = article.author) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref7 !== void 0 ? ref7 : ""
                        ],
                        tags: article.tags && article.tags.map(function(tag) {
                            return tag.name;
                        })
                    },
                    images: [
                        {
                            url: (ref8 = (ref2 = article.cover) === null || ref2 === void 0 ? void 0 : ref2.url) !== null && ref8 !== void 0 ? ref8 : "",
                            alt: (ref9 = (ref3 = article.cover) === null || ref3 === void 0 ? void 0 : ref3.alternativeText) !== null && ref9 !== void 0 ? ref9 : components_Image/* defaultAlt */.Zp
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* ArticleJsonLd */.dX, {
                url: "".concat(appClientConfig/* appClientConfig.recruitWebUrl */.p.recruitWebUrl, "articles/").concat(article.slug),
                title: JSON.stringify(article.title).replace(/(^"|"$)/g, ""),
                images: [
                    (ref10 = (ref4 = article.cover) === null || ref4 === void 0 ? void 0 : ref4.url) !== null && ref10 !== void 0 ? ref10 : ""
                ],
                datePublished: article.published_date,
                dateModified: article.published_date,
                authorName: (ref11 = (ref5 = article.author) === null || ref5 === void 0 ? void 0 : ref5.name) !== null && ref11 !== void 0 ? ref11 : "",
                description: JSON.stringify(article.blurb).replace(/(^"|"$)/g, ""),
                publisherName: "Medrecruit",
                publisherLogo: "".concat(appClientConfig/* appClientConfig.recruitWebUrl */.p.recruitWebUrl, "logo2x.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                itemListElements: [
                    {
                        position: 1,
                        name: "Articles",
                        item: path/* PATH.ARTICLES */.m.ARTICLES
                    },
                    {
                        position: 2,
                        name: "Category",
                        item: "".concat(path/* PATH.ARTICLE_CATEGORY */.m.ARTICLE_CATEGORY, "/").concat((ref6 = article.article_category) === null || ref6 === void 0 ? void 0 : ref6.slug)
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Article, {
                article: article,
                user: user,
                relatedArticles: relatedArticles,
                articleCtaPosition: articleCtaPosition
            })
        ]
    });
};
/* harmony default export */ var _slug_ = (Post);


/***/ }),

/***/ 42361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useCloseOnOutsideClick; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useCloseOnOutsideClick(isOpen, onToggle) {
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    // close if clicked outside
    var handleOutsideClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (isOpen) {
            var ref;
            if ((ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target)) {
                // inside click
                return;
            }
            // outside click
            onToggle(false);
        }
    }, [
        isOpen
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("mousedown", handleOutsideClick);
        return function() {
            return document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [
        handleOutsideClick
    ]);
    return containerRef;
}


/***/ }),

/***/ 85474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Button_container__wxGrQ","myButton":"Button_myButton__0wSRl"};

/***/ }),

/***/ 14300:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleCallToAction_container__yB4MC","ctaButton":"ArticleCallToAction_ctaButton__39Ecu","text":"ArticleCallToAction_text__zqQI_"};

/***/ }),

/***/ 10788:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__XwkUb","cover":"style_cover__YBiHl","content":"style_content__xVZMv","image":"style_image__bc73s","topLeft":"style_topLeft__uFJUK","link":"style_link__icwt9","blurb":"style_blurb__HXp5m","title":"style_title__Xuv9Z"};

/***/ }),

/***/ 51196:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__F3un_","tag":"style_tag__z8jY2"};

/***/ }),

/***/ 90561:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__iCxoM","avatar":"style_avatar__Wnjbz","introduction":"style_introduction__Ogf7q","date":"style_date__2NIru","name":"style_name__WWKA8"};

/***/ }),

/***/ 88460:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"childrenContainer":"style_childrenContainer__d3pAq"};

/***/ }),

/***/ 55530:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"markdown":"style_markdown__RFcTe"};

/***/ }),

/***/ 91066:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageAndLinkTitle":"style_imageAndLinkTitle____viQ","videoPlayer":"style_videoPlayer__ZQkbF"};

/***/ }),

/***/ 88415:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"containerMarginL":"style_containerMarginL__Xin_m","containerMarginM":"style_containerMarginM__gcEkK","containerMarginS":"style_containerMarginS__uOEYv","containerPaddingS":"style_containerPaddingS__F37JV","markdownContent":"style_markdownContent__x1pNa"};

/***/ }),

/***/ 36135:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FieldError_container__A6ve3","iconContainer":"FieldError_iconContainer__gabBf","error":"FieldError_error__AoNkm"};

/***/ }),

/***/ 4423:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"popper":"ShareContainer_popper__X1uVQ","dropdownContainer":"ShareContainer_dropdownContainer__rv05R","item":"ShareContainer_item__XEkFy","button":"ShareContainer_button__kMMgg"};

/***/ }),

/***/ 68818:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsAndConditions_container__arBDJ","terms":"TermsAndConditions_terms__1pvfE","link":"TermsAndConditions_link__D3LrK"};

/***/ }),

/***/ 61195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"TextField_container__04uDw","error":"TextField_error__9Xacv","focusedLabel":"TextField_focusedLabel__bYdK6","filledLabel":"TextField_filledLabel__s7nvP"};

/***/ }),

/***/ 6705:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"TickList_container__Q0_9p","listItem":"TickList_listItem__KXl7I","checkIcon":"TickList_checkIcon__W2Bql","container_small":"TickList_container_small__k5lqe"};

/***/ }),

/***/ 2043:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ctaBannerBottom":"ArticleContentWithCta_ctaBannerBottom__r3yGy"};

/***/ }),

/***/ 6244:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"salaryGuide":"SalaryGuide_salaryGuide__2DT0Q","salaryGuideTitle":"SalaryGuide_salaryGuideTitle__m_AYv","subHeading":"SalaryGuide_subHeading___fzAN","listItem":"SalaryGuide_listItem__Q6_ju","downloadText":"SalaryGuide_downloadText__F7w0w","formContainer":"SalaryGuide_formContainer__CZI3I"};

/***/ }),

/***/ 17798:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__ZrHMD","path":"style_path__wwdnx","title":"style_title__WGwAJ","line":"style_line__xkrKb","authorAndShare":"style_authorAndShare__jmRnF","share":"style_share__dssbT","tag":"style_tag__xEX3w","author":"style_author__1KHDs","relatedArticleTitle":"style_relatedArticleTitle__ftNZK","relatedArticles":"style_relatedArticles__fFdYg","articles":"style_articles__BGKMv","ctaContainer":"style_ctaContainer__IQ8kw"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2491,5675,1399,4872,807,9803,2283,724,8966,4485,4873,8612,5767,7243,554,5545,9774,2888,179], function() { return __webpack_exec__(80617); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);